import PropTypes from 'prop-types';
import ticketDocument from './ticketDocument';
import feesPropType from './fees';
import products from './products';
import classOfService from './classOfService';

export default PropTypes.shape({
  trainNumber: PropTypes.string,
  classOfAccommodation: PropTypes.shape({
    code: PropTypes.string
  }),
  classOfService: classOfService,
  ticketDocuments: PropTypes.arrayOf(ticketDocument),
  origin: PropTypes.shape({
    name: PropTypes.string,
    uic: PropTypes.string,
    shortCode: PropTypes.string
  }),
  destination: PropTypes.shape({
    name: PropTypes.string,
    uic: PropTypes.string,
    shortCode: PropTypes.string
  }),
  timing: PropTypes.shape({
    date: PropTypes.string,
    departs: PropTypes.string,
    arrives: PropTypes.string
  }),
  meals: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string
    })
  ),
  bookingItems: products,
  products,
  fees: feesPropType,
  seats: PropTypes.array,
  departureDate: PropTypes.string,
  departureTime: PropTypes.string,
  arrivalTime: PropTypes.string,
  className: PropTypes.string
});
